
"use strict";
import $ from 'jquery';
import gsap from 'greensock';
import Promise from 'Promise';
import Scroll from '../Scroll';

const TweenLite = gsap.TweenLite;
const TimelineMax = gsap.TimelineMax;

const IN = 1;
const OUT = -1;
const STOPPED = 0;

function noop() {}

function AbstractTransition() {

	let root;
	let tl;

	// Time at which the in finishes and out starts
	let animateInFinishTime;
	let animateOutStartTime;

	// current animState (1/-1)
	let animState;
	let animSuccess;
	let animPromise;
	let animFail;

	function getAnimPromise() {
		cancelTransition();
		return new Promise((resolve, reject) => {
			animSuccess = resolve;
			animFail = reject;
		});
	}

	function cancelTransition() {
		if (animFail) {
			animFail();
		}

		destroyPromise();
	}

	function destroyPromise() {
		animPromise = animFail = animSuccess = null;
	}

	function afterAnimateOut() {
		if (animState === OUT) {
			animSuccess && animSuccess();
			animState = STOPPED;
			(this.sleep || noop).call(this);
			destroyPromise();
		}
	}

	function afterAnimateIn() {
		Scroll.refresh();
		if (animState === IN) {
			tl.stop();
			animSuccess && animSuccess();
			animState = STOPPED;
			(this.activate || noop).call(this);
			destroyPromise();
		}
	}

	/**
	Creates TimelineMax for the animation
	*/
	function setTimeline() {
		if (!TimelineMax) throw new Error('TimelineMax not loaded');

		tl = new TimelineMax({
			onComplete: afterAnimateOut,
			onCompleteScope: this,
		});

		tl.stop();
		this.setAnimation(tl, root, setAnimInFinishTime);

		tl.addCallback(afterAnimateIn, animateInFinishTime, null, this);
	}


	function setAnimInFinishTime() {
		animateInFinishTime = tl.totalDuration();
		tl.append(TweenLite.to({}, 1, {}));
		animateOutStartTime = animateInFinishTime + 1;
		return animateOutStartTime;
	}

	this.setupTransition = (node) => {
		root = (typeof node === 'string') ? $(node) : node;
		setTimeline.call(this);
		return this;
	};

	this.getAnimationRoot = () => root;


	/**
	Jumps directly to the IN state of the animation if it exists.
	*/
	this.jumpToInState = () => {
		cancelTransition();
		if (animateInFinishTime && tl) {
			tl.gotoAndStop(animateInFinishTime);
		}

		animState = STOPPED;
		(this.activate || noop).apply(this, arguments);
	};

	/**
	Defaults to fadein/fadeout
	*/
	this.setAnimation = this.setAnimation || function(tl, rootNode, setInEndTime) {
		tl.append( TweenLite.from(rootNode, 1, {opacity:0, ease:Expo.easeIn}) );
		const animateInFinish = setInEndTime();
		tl.insert( TweenLite.to(rootNode, 1, {opacity:0, ease:Expo.easeOut}), animateInFinish);
		return tl;
	};


	this.animateIn = () => {
		if(animPromise && animState === IN) return animPromise;
		animPromise = getAnimPromise();
		(this.wakeup || noop).apply(this, arguments);//passes arguments to the beforeAnimateIn, if any
		animState = IN;
		tl.restart();
		return animPromise;
	};

	this.animateOut = () => {
		if(animPromise && animState === OUT) return animPromise;
		animPromise = getAnimPromise();
		(this.deactivate || noop).apply(this, arguments);//passes arguments to the beforeAnimateOut, if any
		animState = OUT;
		tl.play(animateOutStartTime);
		return animPromise;
	};

	return this;

};

export function factory(instance) {
	instance = instance || {};
	return AbstractTransition.call(instance);
};
